let initialized = false;

const attachAll = () => {
  if (initialized) return

  document.addEventListener('click', function(event) {
    if(event.target.dataset['dismiss'] === 'bulletin') {
      let bulletin = event.target.closest('.bulletin')
      let container = bulletin.closest('.bulletin-board')
      bulletin.dispatchEvent(new CustomEvent('closed'))
      bulletin.remove()

      // Remove container if this was the last bulletin.
      if(container.children.length === 0) container.remove();
    }
  });

  initialized = true
}

export default { attachAll }
